import React from 'react'
import { Container, Row ,Col } from 'react-bootstrap'
import Section from '../../../Utilitis/Section'
import Statistiuqe from '../../../Utilitis/Statistique/Statistiuqe'

export default function Statistiques() {
    return (
        <Section bg="#FBFBFB" bg_Img={"/images/courses_background.jpg"}>
            <Container>
                <Row>
                    <Col lg="3" md={4} sm={6} xs={12}> <Statistiuqe image={"images/graduate.png"} number={100} title="Studient"  /> </Col>
                    <Col lg="3" md={4} sm={6} xs={12}> <Statistiuqe image={"images/teacher.png"} number={50} title="Teachers" /> </Col>
                    <Col lg="3" md={4} sm={6} xs={12}> <Statistiuqe image={"images/online-course.png"} number={60} title="Courses" /> </Col>
                    <Col lg="3" md={4} sm={6} xs={12}> <Statistiuqe image={"images/event.png"} number={40} title="Events" /> </Col>
                </Row>
            </Container>
        </Section>
    )
}
